export enum TurnoverAuditMode {
  ELAPSED_DAYS = 'ELAPSED_DAYS',
  LOST_REVENUE = 'LOST_REVENUE',
}
